import { RouteNames } from '@/shared/config/routes';
import { MANUAL_NODES } from '@/shared/config/manual';
import type { Badges } from '@/entities/layout';
import type { NavigationItem } from './types';

export const STATIC_MENU_ITEMS: NavigationItem[] = [
  {
    code: 'DASHBOARD',
    label: 'Dashboard',
    icon: 'LayoutDashboard',
    helpContentId: MANUAL_NODES.DASHBOARD,
    subItems: [
      {
        code: 'DASHBOARD_STORAGE',
        label: 'Storage Overview',
        path: RouteNames.DASHBOARD_STORAGE,
        icon: 'Database',
        helpContentId: MANUAL_NODES.STORAGE_OVERVIEW
      },
      {
        code: 'DASHBOARD_TRANSPORT',
        label: 'Transport Overview',
        path: RouteNames.DASHBOARD_TRANSPORT,
        icon: 'Package',
        helpContentId: MANUAL_NODES.TRANSPORT_OVERVIEW
      },
      {
        code: 'DASHBOARD_SERVICE_USERS',
        label: 'Service Users',
        path: RouteNames.DASHBOARD_SERVICE_USERS,
        icon: 'Users',
        helpContentId: MANUAL_NODES.SERVICE_USERS
      },
      {
        code: 'DASHBOARD_MAPPING',
        label: 'Mapping',
        path: RouteNames.DASHBOARD_MAPPING,
        icon: 'Map',
        helpContentId: MANUAL_NODES.MAPPING
      }
    ]
  }
];

/**
 * Translation keys for menu entries legacy RITA does not label through its
 * `listaction_MM_*` scheme: group headers, and the Dashboard pages, which are
 * new UI and reuse their own page titles.
 */
export const NAVIGATION_LABEL_KEYS: Record<string, string> = {
  DASHBOARD: 'navigation.dashboard',
  CONSIGNMENTS_GROUP: 'listaction.MM.CRQ',
  RECEIVES_GROUP: 'listaction.MM.DLV',
  SERVICE_REQUESTS: 'cmrlist.service.request.title',
  RECEIVE_HISTORY: 'receive.history.title',
  RECEIVE_LOSSES: 'receive.losses.title',
  DISPATCH_GROUP: 'listaction.MM.DSP',
  DISPATCH_IN_PROGRESS: 'dispatch.inprogress.history.title',
  DASHBOARD_STORAGE: 'report.storageOverview.title',
  DASHBOARD_TRANSPORT: 'report.transport.overview.title',
  DASHBOARD_SERVICE_USERS: 'welcome.serviceusers.label',
  DASHBOARD_MAPPING: 'welcome.mapping.label'
};

export const DEFAULT_ICON = 'FileText';

/**
 * Manual node per dynamic (backend-driven) menu item code.
 */
export const MENU_ITEM_MANUAL_NODES: Record<string, number> = {
  CONSIGNMENTS_GROUP: MANUAL_NODES.CONSIGNMENTS_LIST,
  CRQ: MANUAL_NODES.CONSIGNMENTS_LIST,
  SERVICE_REQUESTS: MANUAL_NODES.ONLINE_SRFS_LIST,
  RECEIVES_GROUP: MANUAL_NODES.RECEIVE,
  DLV: MANUAL_NODES.RECEIVE,
  RECEIVE_HISTORY: MANUAL_NODES.RECEIVE_HISTORY,
  RECEIVE_LOSSES: MANUAL_NODES.RECEIVE_LOSSES,
  DISPATCH_GROUP: MANUAL_NODES.DISPATCH_PLANNING_STOCK_ON_HAND,
  DSP: MANUAL_NODES.DISPATCH_PLANNING_STOCK_ON_HAND,
  DISPATCH_IN_PROGRESS: MANUAL_NODES.DISPATCH_IN_PROGRESS_HISTORY,
  WHM: MANUAL_NODES.WAREHOUSE_MANAGEMENT,
  RPT: MANUAL_NODES.REPORT_TRANSPORT_PLANNING
};

/**
 * Badge counter (from `menu.badges`) that belongs to each menu item. The
 * backend ships the counters as one flat object per project/site, so the
 * item-to-counter mapping lives here. Both follow legacy RITA, which prints
 * the same two counts on the consignment list (`cmrlist_service_requests_label`)
 * and on stock management (`warehouse_release_orders_label`) — release orders
 * are approved there, not on the dispatch screen.
 */
export const MENU_ITEM_BADGE_KEYS: Record<string, keyof Badges> = {
  SERVICE_REQUESTS: 'serviceRequests',
  WHM: 'releaseOrders'
};
